<div id="application-dashboard" class="content">
  <div *ngIf="filteredApps && filteredApps.length == 0" style="padding: 50px 0px 75px; text-align:center">
    <p>
    <h2>No applications found.</h2>
  </div>
  <div id="application-grid" class="dashboard" *ngIf='filteredApps && filteredApps.length'>
    <div id="apps" class="card-deck justify-content-center no-gutters">
      <div class="col-lg-3 col-md-6" *ngFor='let app of filteredApps'>
        <a id={{app.appName|removewhitespaces}} [routerLink]="[app.appName, app.applicationId]">
          <div class="card application" [style]="'--iconp: ' + app.primaryColor + '; --icons: ' + app.secondaryColor">
            <div class="card-img-top">
              <div [class]="app.appName">
                <p class="card-title">{{app.appName}}</p>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>